import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { BehaviorSubject } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RightHoldersService {
  private _isLoading$ = new BehaviorSubject<boolean>(false);
  private _isLoadingForm$ = new BehaviorSubject<boolean>(false);
  private _isLoadingtable$ = new BehaviorSubject<boolean>(false);

  private apiUrl = environment.apiUrl;
  constructor(private http: HttpClient) { }

  get isLoading$() {
    return this._isLoading$.asObservable();
  }

  get isLoadingtable$() {
    return this._isLoadingtable$.asObservable();
  }

  get isLoadingForm$() {
    return this._isLoadingForm$.asObservable();
  }



  create(admin: any) {
    this._isLoading$.next(true);
    return this.http.post(`${this.apiUrl}/rights/holders/add`, admin).pipe(
      finalize(() => {
        this._isLoading$.next(false)
      })
    );
  }

  getall(params) {
    this._isLoadingtable$.next(true);
    return this.http.post(`${this.apiUrl}/rights/holders/latest`, params).pipe(
      finalize(() => {
        this._isLoadingtable$.next(false)
      })
    );
  }

  getallrightholder() {
    this._isLoadingtable$.next(true);
    return this.http.post(`${this.apiUrl}/general/account`, { type: 4 }).pipe(
      finalize(() => {
        this._isLoadingtable$.next(false)
      })
    );
  }

  GetCountRightHolder(param){
    return this.http.post(`${this.apiUrl}/rights/holders/latest/count`, param);
  }


  delete(id) {
    return this.http.put(`${this.apiUrl}/rights/holders/change-status/${id}`, { status: 3 });
    // return this.http.delete(`${this.apiUrl}/user/${id}`);
  }

  delete_pdf(req) {
    
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: req
    };
    return this.http.delete(`${this.apiUrl}/rights/holders/file`, options);
    
  }

  changestatus(id, status) {
    return this.http.put(`${this.apiUrl}/rights/holders/change-status/${id}`, { status });
  }

  getById(id) {
    return this.http.patch(`${this.apiUrl}/rights/holders/detail/${id}`, {});
  }

  getByIdTeam(id){
    return this.http.patch(`${this.apiUrl}/team/member/${id}`, {});
  }

  update(admin: any, id) {
    this._isLoading$.next(true);
    return this.http.put(`${this.apiUrl}/rights/holders/${id}`, admin).pipe(
      finalize(() => {
        this._isLoading$.next(false)
      })
    );
  }

  currencyForm(body: any) {
    this._isLoadingForm$.next(true);
    return this.http.post(`${this.apiUrl}/payment/history/wise/dynamic/form`, body).pipe(
      finalize(() => {
        this._isLoadingForm$.next(false)
      })
    );
  }

  addPayment(body: any) {
    this._isLoadingForm$.next(true);
    return this.http.post(`${this.apiUrl}/payment/history/wise/account/create`, body).pipe(
      finalize(() => {
        this._isLoadingForm$.next(false)
      })
    );
  }

  getTeamMembers(params) {
    this._isLoadingtable$.next(true);
    return this.http.post(`${this.apiUrl}/team/member`, params).pipe(
      finalize(() => {
        this._isLoadingtable$.next(false)
      })
    );
  }

  deleteTeamMember(id) {
    return this.http.delete(`${this.apiUrl}/team/member/${id}`);
  }

  updateTeamMember(admin: any, id) {
    this._isLoading$.next(true);
    return this.http.put(`${this.apiUrl}/team/member/${id}`, admin).pipe(
      finalize(() => {
        this._isLoading$.next(false)
      })
    );
  }

  addTeamMembers(payload: any) {
    return this.http.post(`${this.apiUrl}/team/member/add`, payload);
  }

  changeTeamMembersStatus(admin: any,id) {
    return this.http.put(`${this.apiUrl}/team/member/change-status/${id}`, admin);
  }

  sendWelcomeEmail(id: string) {
    return this.http.post(`${this.apiUrl}/rights/holders/email/send`, { userId: id });
  }

  getStripePlans() {
    return this.http.get(`${this.apiUrl}/stripe/active/plan`, {});
  }
}
